import { HttpParamsOptions } from '@angular/common/http';

import { BarHttpParams } from '@lvflanders/bar-ng';

// https://stackoverflow.com/a/46078299/2174621
export class BarLayoutHttpParams extends BarHttpParams {
    constructor(
        /** This means that the request should block the user interface */
        public blocking = true,
        /**This means this is a request that should pass the interceptor but happens in background*/
        backgroundRequest = false,
        /**This means interception should be ommited*/
        ommitInterceptor = false,
        options?: HttpParamsOptions
    ) {
        super(backgroundRequest, ommitInterceptor, options);
    }
}
